import axios from "axios";
import TokenService from "./TokenService.ts";

const instance = axios.create({
    baseURL: process.env.REACT_APP_DB_URI,
    headers: {
        "Content-Type": "application/json",
    },
});

instance.interceptors.request.use(
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;

        if (originalConfig.url !== "/users/user-login/login/" && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const refreshToken = TokenService.getLocalRefreshToken(); // Get refresh token directly from service

                    if (!refreshToken) {
                        TokenService.removeUser();
                        window.location.href = "/";
                        return Promise.reject(err);
                    }

                    const rs = await instance.post("/users/user-login/refresh-token/", {
                        refresh: refreshToken,
                    });

                    const { access, refresh } = rs.data;

                    TokenService.updateLocalAccessToken(access);
                    if (refresh) {
                        TokenService.updateLocalRefreshToken(refresh);
                    }

                    return instance(originalConfig);
                } catch (_error) {
                    TokenService.removeUser();
                    window.location.href = "/";
                    return Promise.reject(_error);
                }
            }
        }

        return Promise.reject(err);
    }
);

export default instance;
